export default "__VITE_ASSET__BqrvxKoF__"